import ApplyV2Switch from '@core/components/ApplyDialogV2/ApplyV2Switch'
import ApplyV2InputText from '@core/components/ApplyDialogV2/ApplyV2InputText'
import ApplyV2Select from '@core/components/ApplyDialogV2/ApplyV2Select'
import ApplyV2InputRate from '@core/components/ApplyDialogV2/ApplyV2InputRate'
import ApplyV2Checkbox from '@core/components/ApplyDialogV2/ApplyV2Checkbox'
import { useApplyV2Context } from '@core/utils/contexts/ApplyV2ModalContext/ApplyV2ModalContext'
import decodeHtmlEntitiesRecursive from '@core/utils/helpers/decodeHtmlEntitiesRecursive'
import ApplyV2DataRow from '@core/components/ApplyDialogV2/ApplyV2DataRow'
import ApplyV2Button from '@core/components/ApplyDialogV2/ApplyV2Button'
import ApplyV2Accordion from '@core/components/ApplyDialogV2/ApplyV2Accordion'
import ApplyV2Textarea from '@core/components/ApplyDialogV2/ApplyV2Textarea'
import useFormattedDatesPeriod from '@core/utils/hooks/useFormattedDatesPeriod'
import ApplyV2Card from '@core/components/ApplyDialogV2/ApplyV2Card'
import useApplyV2NavTranslations from '@core/utils/hooks/useApplyV2NavTranslations'
import ApplyV2CoursesStepAdd from '@core/components/ApplyDialogV2/ApplyV2ReviewApplyStep/ApplyV2ReviewApplyStepItem/ApplyV2ReviewApplyCourse/ApplyV2CoursesStepAdd'
import dayjs from 'dayjs'
import React from 'react'
import type { ApplyV2SettingsSectionName, GetApplyV2SettingsResponse } from '@core/app/types/applyV2Type'
import './ApplyV2CoursesStep.scss'

// interface Props {
//     settingsData: GetApplyV2SettingsResponse | null | undefined
//     navItems: {
//         name: ApplyV2SettingsSectionName
//         visible: boolean
//         required: boolean
//         order: number
//     }[]
// }

const baseClass = 'ApplyV2CoursesStep'

function ApplyV2CoursesStep() {
    const [editState, setEditState] = React.useState<'edit' | 'add' | null>(null)

    const {
        postProfileData,
        postProfileError,
        isPostProfileLoading,
        isPostProfileSuccess,
        isSettingsLoading,
        isSettingsFetching,
        isFinalStep,
        setIsFinalStep,
        isPostApplied,
        onCloseApply,
        settingsData,
        navItems,
    } = useApplyV2Context()
    const { getTitle } = useApplyV2NavTranslations()
    const { formatDateRange, formatDuration } = useFormattedDatesPeriod()

    const course = postProfileData?.data?.course ?? []

    console.log(course)

    if (editState === 'add') {
        return <ApplyV2CoursesStepAdd />
    }

    return (
        <div className={baseClass}>
            <div className={`${baseClass}__container`}>
                <div className={`${baseClass}__items`}>
                    {course.map((item) => (
                        <ApplyV2Card
                            key={item.uid ?? item.existingId}
                            className={`${baseClass}__items--course`}
                            title={decodeHtmlEntitiesRecursive(item.courseName)}
                            files={item.files}
                            dateSection={
                                <div className={`${baseClass}__items--course-period`}>
                                    <span>
                                        {formatDateRange(item.startDate, item.endDate, {
                                            dateFormat: 'D MMM YYYY',
                                        })}
                                    </span>
                                    <span className={`${baseClass}__items--course-period-total`}>
                                        {` (${formatDuration(item.startDate, item.endDate, {
                                            showMonths: true,
                                        })})`}
                                    </span>
                                </div>
                            }
                        >
                            {decodeHtmlEntitiesRecursive(item.courseDescription)}
                        </ApplyV2Card>
                    ))}
                    <ApplyV2Button
                        variant={'transparent'}
                        className={`${baseClass}__addBtn`}
                        onClick={() => {
                            setEditState('add')
                        }}
                        leftIcon={
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M7.99967 1.33301C8.36786 1.33301 8.66634 1.63148 8.66634 1.99967V7.12611H13.9997C14.3679 7.12611 14.6663 7.42459 14.6663 7.79278C14.6663 8.16097 14.3679 8.45944 13.9997 8.45944H8.66634V13.9997C8.66634 14.3679 8.36786 14.6663 7.99967 14.6663C7.63148 14.6663 7.33301 14.3679 7.33301 13.9997V8.45944H1.99967C1.63148 8.45944 1.33301 8.16097 1.33301 7.79278C1.33301 7.42459 1.63148 7.12611 1.99967 7.12611H7.33301V1.99967C7.33301 1.63148 7.63148 1.33301 7.99967 1.33301Z"
                                    fill="#19191A"
                                />
                            </svg>
                        }
                    >
                        {getTitle('1533', 'Add course/certification')}
                    </ApplyV2Button>
                </div>
            </div>
            <div className={`${baseClass}__next`}>
                <ApplyV2Button
                    variant={'primary'}
                    className={`${baseClass}__next--btn`}
                    onClick={() => {
                        console.log('On next click')
                    }}
                    isLoading={isPostApplied || isPostProfileLoading}
                    isDisabled={isPostApplied || isPostProfileLoading}
                    type={'submit'}
                >
                    {getTitle('3035', 'Next')}
                </ApplyV2Button>
            </div>
        </div>
    )
}

export default ApplyV2CoursesStep
